import { Button, CloseButton, IconButton, SaveButton } from '@ui/shared/Button';
import isEmpty from 'lodash/isEmpty';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import {
  closeInnerPopup,
  openInnerPopup,
} from '../../../data/providers/popupsProvider';
import { ITag } from '../../../data/types';
import { updateTag } from '../../../data/writers/tags';
import { CardBody } from '../../shared/card/CardBody';
import {
  CardFooter,
  CardFooterLeft,
  CardFooterRight,
} from '../../shared/card/CardFooter';
import {
  CardHeader,
  CardHeaderLeft,
  CardHeaderRight,
} from '../../shared/card/CardHeader';
import {
  InnerPopupCard,
  PopupCardContent,
} from '../../shared/popups/PopupCard';
import { TagForm } from './TagForm';

interface IProps extends RouteComponentProps {
  tag: ITag;
}

export const EditTag = withRouter((props: IProps): React.ReactElement => {
  const openDialog = (): void =>
    openInnerPopup(
      <EditTagPopupCard
        onClose={closeInnerPopup(props.history)}
        tag={props.tag}
      />,
      props.history,
      'editTag'
    );

  return <IconButton icon='edit' onClick={openDialog} title='Edit Tag' />;
});

interface IEditTagProps {
  onClose: () => void;
  tag: ITag;
}

const EditTagPopupCard = (props: IEditTagProps): React.ReactElement => {
  const [name, setName] = React.useState<string>(props.tag.name);
  const [description, setDescription] = React.useState<string>(
    props.tag.description
  );
  const [excludeWeight, setExcludeWeight] = React.useState<boolean>(
    props.tag.exclude_weight
  );

  const toggleExcludeWeight = (): void => setExcludeWeight(!excludeWeight);

  const saveTag = (): void => {
    updateTag({
      id: props.tag.id,
      name,
      description: description || '',
      exclude_weight: excludeWeight,
      exclude_aggregates: false,
      active: true,
    });
    props.onClose();
  };

  const toggleDisable = async (): Promise<void> => {
    await updateTag({
      id: props.tag.id,
      name,
      description: description || '',
      exclude_weight: excludeWeight,
      exclude_aggregates: false,
      active: props.tag.active ? false : true,
    });
    props.onClose();
  };

  const activeToggleTitle = props.tag.active ? 'Disable' : 'Enable';
  const activeToggleFlavor = props.tag.active ? 'danger' : 'primary';

  return (
    <InnerPopupCard onClose={props.onClose} size='medium'>
      <PopupCardContent>
        <CardHeader surface={8}>
          <CardHeaderLeft>
            <h5>Edit Tag</h5>
          </CardHeaderLeft>
          <CardHeaderRight>
            <CloseButton onClick={props.onClose} />
          </CardHeaderRight>
        </CardHeader>
        <CardBody style={{ padding: '20px' }}>
          <TagForm
            tag={{
              name,
              description,
              exclude_weight: excludeWeight,
            }}
            updateName={setName}
            updateDesc={setDescription}
            toggle={toggleExcludeWeight}
          />
        </CardBody>
        <CardFooter surface={8}>
          <CardFooterLeft>
            <Button
              onClick={toggleDisable}
              title={activeToggleTitle}
              flavor={activeToggleFlavor}
             />
          </CardFooterLeft>
          <CardFooterRight>
            <SaveButton
              disabled={!name || isEmpty(name)}
              onClick={saveTag}
              type='submit'
            />
          </CardFooterRight>
        </CardFooter>
      </PopupCardContent>
    </InnerPopupCard>
  );
};
